import { Outlet } from 'react-router';
import { CheckoutLayout } from '@/components/checkout-layout';

export function CheckoutRoute() {
  return (
    <CheckoutLayout>
      <Outlet />
    </CheckoutLayout>
  );
}
